module.exports = __webpack_public_path__ + "img/coffee_machine.d896ed4d.png";